const PILLARS = [
  {
    title: '絶対BANされない',
    lead: '動画の内容を理由に、利用を止めません。',
    body: 'アダルト事業者が扱う素材であることを理由に、アカウントを停止したり、ファイルを削除したりしません。ある日突然、案件のデータが開けなくなることはありません。',
    visual: 'shield',
  },
  {
    title: '爆速アップロード',
    lead: '重い動画も、待たずに送れます。',
    body: '撮影が終わったら、スマホやパソコンからそのまま送信。容量の大きな動画でも、アップロードの待ち時間を短くできます。',
    visual: 'speed',
  },
] as const

export function LandingPillars() {
  return (
    <section className="border-t border-border bg-muted/40">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24">
        <div className="grid gap-5 md:grid-cols-2">
          {PILLARS.map((pillar) => (
            <article
              key={pillar.title}
              className="landing-rise overflow-hidden rounded-[28px] border border-border bg-white p-6 shadow-xl shadow-zinc-950/[0.04] sm:p-8"
            >
              <PillarVisual kind={pillar.visual} />
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight bg-gradient-primary bg-clip-text text-transparent">
                {pillar.title}
              </h2>
              <p className="mt-3 text-lg font-semibold tracking-tight">{pillar.lead}</p>
              <p className="mt-3 text-sm leading-7 text-muted-foreground sm:text-base">
                {pillar.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

function PillarVisual({ kind }: { kind: 'shield' | 'speed' }) {
  return (
    <div className="mb-7 flex h-36 items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-br from-accent to-white">
      {kind === 'shield' ? (
        <div className="relative flex h-24 w-20 items-center justify-center rounded-[24px_24px_38px_38px] bg-gradient-primary shadow-xl shadow-primary/25">
          <span className="text-3xl font-black text-white">✓</span>
          <span className="absolute -right-12 top-3 rounded-full border border-primary/10 bg-white px-3 py-1.5 text-[10px] font-bold text-primary shadow-md">
            DATA SAFE
          </span>
        </div>
      ) : (
        <div className="w-44 space-y-3">
          {[92, 68, 100].map((width, index) => (
            <div key={width} className="flex items-center gap-3">
              <span className="font-mono text-[10px] text-primary">0{index + 1}</span>
              <span
                className="h-3 rounded-full bg-gradient-primary shadow-sm shadow-primary/20"
                style={{ width: `${width}%` }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
